import { InfoCircleOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { ReactNode } from "react";

function ExportPdfPrintModal({
  content,
  onProceed
}: {
  content: ReactNode;
  onProceed: () => void;
}) {
  Modal.confirm({
    title: "Export PDF/Print",
    content,
    okText: "Export",
    cancelText: "Cancel",
    onOk: onProceed,
    width: 520,
    closable: true,
    centered: true,
    icon: <InfoCircleOutlined style={{ color: "#1677FF" }} />
  });
}

export default ExportPdfPrintModal;
